import React, { useState } from "react";
import { Button, Form, Drawer, Input, message, Select, DatePicker } from "antd";
import axios from "axios";
import Cookies from "universal-cookie";
import dayjs from "dayjs";
// import jwtDecode from "jwt-decode";
import TextArea from "antd/es/input/TextArea";
// import AsyncSelect from "react-select/async";
import "./recruitmenttrackers.css";

const RecruitmentTrackerForm = ({
  isModalOpen,
  setModal,
  editData,
  setEditData,
  getData,
  clientsList,
  clientFetching,
  candidateList,
  candidateFetching,
  jobsList,
  jobFetching,
  filter,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const cookies = new Cookies();
  const token = cookies.get("token");
  // const user = token && jwtDecode(token);
  // const [name, setName] = useState(
  //   (editData && {
  //     label: editData?.candidateName,
  //     value: editData?.candidate,
  //   }) ||
  //     null
  // );



  const status = [
    {
      id: 1,
      label: "shotlisted",
      value: "shortlisted",
    },
    {
      id: 2,
      label: "not shortlisted",
      value: "not shortlisted",
    },
  ];

  const cvuploaded = [
    {
      id: 1,
      label: "Yes",
      value: "Yes",
    },
    {
      id: 2,
      label: "No",
      value: "No",
    },
  ];

  const nation = [
    {
      id: 1,
      label: "Afghanistan",
      value: "Afghanistan",
    },
    {
      id: 2,
      label: "Aland Islands",
      value: "Aland Islands",
    },
    {
      id: 3,
      label: "Albania",
      value: "Albania",
    },
    {
      id: 4,
      label: "Algeria",
      value: "Algeria",
    },
    {
      id: 5,
      label: "American Samoa",
      value: "American Samoa",
    },
    {
      id: 6,
      label: "Andorra",
      value: "Andorra",
    },
    {
      id: 7,
      label: "Angola",
      value: "Angola",
    },
    {
      id: 8,
      label: "Anguilla",
      value: "Anguilla",
    },
    {
      id: 9,
      label: "Antarctica",
      value: "Antarctica",
    },
    {
      id: 10,
      label: "Antigua and Barbuda",
      value: "Antigua and Barbuda",
    },
    {
      id: 11,
      label: "Argentina",
      value: "Argentina",
    },
    {
      id: 12,
      label: "Armenia",
      value: "Armenia",
    },
    {
      id: 13,
      label: "Aruba",
      value: "Aruba",
    },
    {
      id: 14,
      label: "Australia",
      value: "Australia",
    },
    {
      id: 15,
      label: "Austria",
      value: "Austria",
    },
    {
      id: 16,
      label: "Azerbaijan",
      value: "Azerbaijan",
    },
    {
      id: 17,
      label: "Bahamas",
      value: "Bahamas",
    },
    {
      id: 18,
      label: "Bahrain",
      value: "Bahrain",
    },
    {
      id: 19,
      label: "Bangladesh",
      value: "Bangladesh",
    },
    {
      id: 20,
      label: "Barbados",
      value: "Barbados",
    },
    {
      id: 21,
      label: "Belarus",
      value: "Belarus",
    },
    {
      id: 22,
      label: "Belgium",
      value: "Belgium",
    },
    {
      id: 23,
      label: "Belize",
      value: "Belize",
    },
    {
      id: 24,
      label: "Benin",
      value: "Benin",
    },
    {
      id: 25,
      label: "Bermuda",
      value: "Bermuda",
    },
    {
      id: 26,
      label: "Bhutan",
      value: "Bhutan",
    },
    {
      id: 27,
      label: "Bolivia (Plurinational State of)",
      value: "Bolivia (Plurinational State of)",
    },
    {
      id: 28,
      label: "Bonaire",
      value: "Bonaire",
    },
    {
      id: 29,
      label: "Bosnia and Herzegovina",
      value: "Bosnia and Herzegovina",
    },
    {
      id: 30,
      label: "Botswana",
      value: "Botswana",
    },
    {
      id: 31,
      label: "Bouvet Island",
      value: "Bouvet Island",
    },
    {
      id: 32,
      label: "Brazil",
      value: "Brazil",
    },
    {
      id: 33,
      label: "British Indian Ocean Territory",
      value: "British Indian Ocean Territory",
    },
    {
      id: 34,
      label: "Brunei Darussalam",
      value: "Brunei Darussalam",
    },
    {
      id: 35,
      label: "Bulgaria",
      value: "Bulgaria",
    },
    {
      id: 36,
      label: "Burkina Faso",
      value: "Burkina Faso",
    },
    {
      id: 37,
      label: "Burundi",
      value: "Burundi",
    },
    {
      id: 38,
      label: "Cabo Verde",
      value: "Cabo Verde",
    },
    {
      id: 39,
      label: "Cambodia",
      value: "Cambodia",
    },
    {
      id: 40,
      label: "Cameroon",
      value: "Cameroon",
    },
    {
      id: 41,
      label: "Canada",
      value: "Canada",
    },
    {
      id: 42,
      label: "Cayman Islands",
      value: "Cayman Islands",
    },
    {
      id: 43,
      label: "Central African Republic",
      value: "Central African Republic",
    },
    {
      id: 44,
      label: "Chad",
      value: "Chad",
    },
    {
      id: 45,
      label: "Chile",
      value: "Chile",
    },
    {
      id: 46,
      label: "China",
      value: "China",
    },
    {
      id: 47,
      label: "Christmas Island",
      value: "Christmas Island",
    },
    {
      id: 48,
      label: "Cocos (Keeling) Islands",
      value: "Cocos (Keeling) Islands",
    },
    {
      id: 49,
      label: "Colombia",
      value: "Colombia",
    },
    {
      id: 50,
      label: "Comoros",
      value: "Comoros",
    },
    {
      id: 51,
      label: "Congo (Republic of the)",
      value: "Congo (Republic of the)",
    },
    {
      id: 52,
      label: "Congo (Democratic Republic of the)",
      value: "Congo (Democratic Republic of the)",
    },
    {
      id: 53,
      label: "Cook Islands",
      value: "Cook Islands",
    },
    {
      id: 54,
      label: "Costa Rica",
      value: "Costa Rica",
    },
    {
      id: 55,
      label: "Cote dIvoire",
      value: "Cote dIvoire",
    },
    {
      id: 56,
      label: "Croatia",
      value: "Croatia",
    },
    {
      id: 57,
      label: "Cuba",
      value: "Cuba",
    },
    {
      id: 58,
      label: "Curacao",
      value: "Curacao",
    },
    {
      id: 59,
      label: "Cyprus",
      value: "Cyprus",
    },
    {
      id: 60,
      label: "Czech Republic",
      value: "Czech Republic",
    },
    {
      id: 61,
      label: "Denmark",
      value: "Denmark",
    },
    {
      id: 62,
      label: "Djibouti",
      value: "Djibouti",
    },
    {
      id: 63,
      label: "Dominica",
      value: "Dominica",
    },
    {
      id: 64,
      label: "Dominican Republic",
      value: "Dominican Republic",
    },
    {
      id: 65,
      label: "Ecuador",
      value: "Ecuador",
    },
    {
      id: 66,
      label: "Egypt",
      value: "Egypt",
    },
    {
      id: 67,
      label: "El Salvador",
      value: "El Salvador",
    },
    {
      id: 68,
      label: "Equatorial Guinea",
      value: "Equatorial Guinea",
    },
    {
      id: 69,
      label: "Eritrea",
      value: "Eritrea",
    },
    {
      id: 70,
      label: "Estonia",
      value: "Estonia",
    },
    {
      id: 71,
      label: "Ethiopia",
      value: "Ethiopia",
    },
    {
      id: 72,
      label: "Falkland Islands (Malvinas)",
      value: "Falkland Islands (Malvinas)",
    },
    {
      id: 73,
      label: "Faroe Islands",
      value: "Faroe Islands",
    },
    {
      id: 74,
      label: "Fiji",
      value: "Fiji",
    },
    {
      id: 75,
      label: "Finland",
      value: "Finland",
    },
    {
      id: 76,
      label: "France",
      value: "France",
    },
    {
      id: 77,
      label: "French Guiana",
      value: "French Guiana",
    },
    {
      id: 78,
      label: "French Polynesia",
      value: "French Polynesia",
    },
    {
      id: 79,
      label: "French Southern Territories",
      value: "French Southern Territories",
    },
    {
      id: 80,
      label: "Gabon",
      value: "Gabon",
    },
    {
      id: 81,
      label: "Gambia",
      value: "Gambia",
    },
    {
      id: 82,
      label: "Georgia",
      value: "Georgia",
    },
    {
      id: 83,
      label: "Germany",
      value: "Germany",
    },
    {
      id: 84,
      label: "Ghana",
      value: "Ghana",
    },
    {
      id: 85,
      label: "Gibraltar",
      value: "Gibraltar",
    },
    {
      id: 86,
      label: "Greece",
      value: "Greece",
    },
    {
      id: 87,
      label: "Greenland",
      value: "Greenland",
    },
    {
      id: 88,
      label: "Grenada",
      value: "Grenada",
    },
    {
      id: 89,
      label: "Guadeloupe",
      value: "Guadeloupe",
    },
    {
      id: 90,
      label: "Guam",
      value: "Guam",
    },
    {
      id: 91,
      label: "Guatemala",
      value: "Guatemala",
    },
    {
      id: 92,
      label: "Guernsey",
      value: "Guernsey",
    },
    {
      id: 93,
      label: "Guinea",
      value: "Guinea",
    },
    {
      id: 94,
      label: "Guinea-Bissau",
      value: "Guinea-Bissau",
    },
    {
      id: 95,
      label: "Guyana",
      value: "Guyana",
    },
    {
      id: 96,
      label: "Haiti",
      value: "Haiti",
    },
    {
      id: 97,
      label: "Heard Island and McDonald Islands",
      value: "Heard Island and McDonald Islands",
    },
    {
      id: 98,
      label: "Vatican City State",
      value: "Vatican City State",
    },
    {
      id: 99,
      label: "Honduras",
      value: "Honduras",
    },
    {
      id: 100,
      label: "Hong Kong",
      value: "Hong Kong",
    },
    {
      id: 101,
      label: "Hungary",
      value: "Hungary",
    },
    {
      id: 102,
      label: "Iceland",
      value: "Iceland",
    },
    {
      id: 103,
      label: "India",
      value: "India",
    },
    {
      id: 104,
      label: "Indonesia",
      value: "Indonesia",
    },
    {
      id: 105,
      label: "Iran",
      value: "Iran",
    },
    {
      id: 106,
      label: "Iraq",
      value: "Iraq",
    },
    {
      id: 107,
      label: "Ireland",
      value: "Ireland",
    },
    {
      id: 108,
      label: "Isle of Man",
      value: "Isle of Man",
    },
    {
      id: 109,
      label: "Israel",
      value: "Israel",
    },
    {
      id: 110,
      label: "Italy",
      value: "Italy",
    },
    {
      id: 111,
      label: "Jamaica",
      value: "Jamaica",
    },
    {
      id: 112,
      label: "Japan",
      value: "Japan",
    },
    {
      id: 113,
      label: "Jersey",
      value: "Jersey",
    },
    {
      id: 114,
      label: "Jordan",
      value: "Jordan",
    },
    {
      id: 115,
      label: "Kazakhstan",
      value: "Kazakhstan",
    },
    {
      id: 116,
      label: "Kenya",
      value: "Kenya",
    },
    {
      id: 117,
      label: "Kiribati",
      value: "Kiribati",
    },
    {
      id: 118,
      label: "Korea (Democratic Peoples Republic of)",
      value: "Korea (Democratic Peoples Republic of)",
    },
    {
      id: 119,
      label: "Korea (Republic of)",
      value: "Korea (Republic of)",
    },
    {
      id: 120,
      label: "Kuwait",
      value: "Kuwait",
    },
    {
      id: 121,
      label: "Kyrgyzstan",
      value: "Kyrgyzstan",
    },
    {
      id: 122,
      label: "Lao Peoples Democratic Republic",
      value: "Lao Peoples Democratic Republic",
    },
    {
      id: 123,
      label: "Latvia",
      value: "Latvia",
    },
    {
      id: 124,
      label: "Lebanon",
      value: "Lebanon",
    },
    {
      id: 125,
      label: "Lesotho",
      value: "Lesotho",
    },
    {
      id: 126,
      label: "Liberia",
      value: "Liberia",
    },
    {
      id: 127,
      label: "Libya",
      value: "Libya",
    },
    {
      id: 128,
      label: "Liechtenstein",
      value: "Liechtenstein",
    },
    {
      id: 129,
      label: "Lithuania",
      value: "Lithuania",
    },
    {
      id: 130,
      label: "Luxembourg",
      value: "Luxembourg",
    },
    {
      id: 131,
      label: "Macao",
      value: "Macao",
    },
    {
      id: 132,
      label: "Macedonia (the former Yugoslav Republic of)",
      value: "Macedonia (the former Yugoslav Republic of)",
    },
    {
      id: 133,
      label: "Madagascar",
      value: "Madagascar",
    },
    {
      id: 134,
      label: "Malawi",
      value: "Malawi",
    },
    {
      id: 135,
      label: "Malaysia",
      value: "Malaysia",
    },
    {
      id: 136,
      label: "Maldives",
      value: "Maldives",
    },
    {
      id: 137,
      label: "Mali",
      value: "Mali",
    },
    {
      id: 138,
      label: "Malta",
      value: "Malta",
    },
    {
      id: 139,
      label: "Marshall Islands",
      value: "Marshall Islands",
    },
    {
      id: 140,
      label: "Martinique",
      value: "Martinique",
    },
    {
      id: 141,
      label: "Mauritania",
      value: "Mauritania",
    },
    {
      id: 142,
      label: "Mauritius",
      value: "Mauritius",
    },
    {
      id: 143,
      label: "Mayotte",
      value: "Mayotte",
    },
    {
      id: 144,
      label: "Mexico",
      value: "Mexico",
    },
    {
      id: 145,
      label: "Micronesia (Federated States of)",
      value: "Micronesia (Federated States of)",
    },
    {
      id: 146,
      label: "Moldova (Republic of)",
      value: "Moldova (Republic of)",
    },
    {
      id: 147,
      label: "Monaco",
      value: "Monaco",
    },
    {
      id: 148,
      label: "Mongolia",
      value: "Mongolia",
    },
    {
      id: 149,
      label: "Montenegro",
      value: "Montenegro",
    },
    {
      id: 150,
      label: "Montserrat",
      value: "Montserrat",
    },
    {
      id: 151,
      label: "Morocco",
      value: "Morocco",
    },
    {
      id: 152,
      label: "Mozambique",
      value: "Mozambique",
    },
    {
      id: 153,
      label: "Myanmar",
      value: "Myanmar",
    },
    {
      id: 154,
      label: "Namibia",
      value: "Namibia",
    },
    {
      id: 155,
      label: "Nauru",
      value: "Nauru",
    },
    {
      id: 156,
      label: "Nepal",
      value: "Nepal",
    },
    {
      id: 157,
      label: "Netherlands",
      value: "Netherlands",
    },
    {
      id: 158,
      label: "New Caledonia",
      value: "New Caledonia",
    },
    {
      id: 159,
      label: "New Zealand",
      value: "New Zealand",
    },
    {
      id: 160,
      label: "Nicaragua",
      value: "Nicaragua",
    },
    {
      id: 161,
      label: "Niger",
      value: "Niger",
    },
    {
      id: 162,
      label: "Nigeria",
      value: "Nigeria",
    },
    {
      id: 163,
      label: "Niue",
      value: "Niue",
    },
    {
      id: 164,
      label: "Norfolk Island",
      value: "Norfolk Island",
    },
    {
      id: 165,
      label: "Northern Mariana Islands",
      value: "Northern Mariana Islands",
    },
    {
      id: 166,
      label: "Norway",
      value: "Norway",
    },
    {
      id: 167,
      label: "Oman",
      value: "Oman",
    },
    {
      id: 168,
      label: "Pakistan",
      value: "Pakistan",
    },
    {
      id: 169,
      label: "Palau",
      value: "Palau",
    },
    {
      id: 170,
      label: "Palestine",
      value: "Palestine",
    },
    {
      id: 171,
      label: "Panama",
      value: "Panama",
    },
    {
      id: 172,
      label: "Papua New Guinea",
      value: "Papua New Guinea",
    },
    {
      id: 173,
      label: "Paraguay",
      value: "Paraguay",
    },
    {
      id: 174,
      label: "Peru",
      value: "Peru",
    },
    {
      id: 175,
      label: "Philippines",
      value: "Philippines",
    },
    {
      id: 176,
      label: "Pitcairn",
      value: "Pitcairn",
    },
    {
      id: 177,
      label: "Poland",
      value: "Poland",
    },
    {
      id: 178,
      label: "Portugal",
      value: "Portugal",
    },
    {
      id: 179,
      label: "Puerto Rico",
      value: "Puerto Rico",
    },
    {
      id: 180,
      label: "Qatar",
      value: "Qatar",
    },
    {
      id: 181,
      label: "Reunion",
      value: "Reunion",
    },
    {
      id: 182,
      label: "Romania",
      value: "Romania",
    },
    {
      id: 183,
      label: "Russian Federation",
      value: "Russian Federation",
    },
    {
      id: 184,
      label: "Rwanda",
      value: "Rwanda",
    },
    {
      id: 185,
      label: "Saint Barthelemy",
      value: "Saint Barthelemy",
    },
    {
      id: 186,
      label: "Saint Helena",
      value: "Saint Helena",
    },
    {
      id: 187,
      label: "Saint Kitts and Nevis",
      value: "Saint Kitts and Nevis",
    },
    {
      id: 188,
      label: "Saint Lucia",
      value: "Saint Lucia",
    },
    {
      id: 189,
      label: "Saint Martin (French part)",
      value: "Saint Martin (French part)",
    },
    {
      id: 190,
      label: "Saint Pierre and Miquelon",
      value: "Saint Pierre and Miquelon",
    },
    {
      id: 191,
      label: "Saint Vincent and the Grenadines",
      value: "Saint Vincent and the Grenadines",
    },
    {
      id: 192,
      label: "Samoa",
      value: "Samoa",
    },
    {
      id: 193,
      label: "San Marino",
      value: "San Marino",
    },
    {
      id: 194,
      label: "Sao Tome and Principe",
      value: "Sao Tome and Principe",
    },
    {
      id: 195,
      label: "Saudi Arabia",
      value: "Saudi Arabia",
    },
    {
      id: 196,
      label: "Senegal",
      value: "Senegal",
    },
    {
      id: 197,
      label: "Serbia",
      value: "Serbia",
    },
    {
      id: 198,
      label: "Seychelles",
      value: "Seychelles",
    },
    {
      id: 199,
      label: "Sierra Leone",
      value: "Sierra Leone",
    },
    {
      id: 200,
      label: "Singapore",
      value: "Singapore",
    },
    {
      id: 201,
      label: "Sint Maarten (Dutch part)",
      value: "Sint Maarten (Dutch part)",
    },
    {
      id: 202,
      label: "Slovakia",
      value: "Slovakia",
    },
    {
      id: 203,
      label: "Slovenia",
      value: "Slovenia",
    },
    {
      id: 204,
      label: "Solomon Islands",
      value: "Solomon Islands",
    },
    {
      id: 205,
      label: "Somalia",
      value: "Somalia",
    },
    {
      id: 206,
      label: "South Africa",
      value: "South Africa",
    },
    {
      id: 207,
      label: "South Georgia and the South Sandwich Islands",
      value: "South Georgia and the South Sandwich Islands",
    },
    {
      id: 208,
      label: "South Sudan",
      value: "South Sudan",
    },
    {
      id: 209,
      label: "Spain",
      value: "Spain",
    },
    {
      id: 210,
      label: "Sri Lanka",
      value: "Sri Lanka",
    },
    {
      id: 211,
      label: "Sudan",
      value: "Sudan",
    },
    {
      id: 212,
      label: "Suriname",
      value: "Suriname",
    },
    {
      id: 213,
      label: "Svalbard and Jan Mayen",
      value: "Svalbard and Jan Mayen",
    },
    {
      id: 214,
      label: "Swaziland",
      value: "Swaziland",
    },
    {
      id: 215,
      label: "Sweden",
      value: "Sweden",
    },
    {
      id: 216,
      label: "Switzerland",
      value: "Switzerland",
    },
    {
      id: 217,
      label: "Syrian Arab Republic",
      value: "Syrian Arab Republic",
    },
    {
      id: 218,
      label: "Taiwan",
      value: "Taiwan",
    },
    {
      id: 219,
      label: "Tajikistan",
      value: "Tajikistan",
    },
    {
      id: 220,
      label: "Tanzania",
      value: "Tanzania",
    },
    {
      id: 221,
      label: "Thailand",
      value: "Thailand",
    },
    {
      id: 222,
      label: "Timor-Leste",
      value: "Timor-Leste",
    },
    {
      id: 223,
      label: "Togo",
      value: "Togo",
    },
    {
      id: 224,
      label: "Tokelau",
      value: "Tokelau",
    },
    {
      id: 225,
      label: "Tonga",
      value: "Tonga",
    },
    {
      id: 226,
      label: "Trinidad and Tobago",
      value: "Trinidad and Tobago",
    },
    {
      id: 227,
      label: "Tunisia",
      value: "Tunisia",
    },
    {
      id: 228,
      label: "Turkey",
      value: "Turkey",
    },
    {
      id: 229,
      label: "Turkmenistan",
      value: "Turkmenistan",
    },
    {
      id: 230,
      label: "Turks and Caicos Islands",
      value: "Turks and Caicos Islands",
    },
    {
      id: 231,
      label: "Tuvalu",
      value: "Tuvalu",
    },
    {
      id: 232,
      label: "Uganda",
      value: "Uganda",
    },
    {
      id: 233,
      label: "Ukraine",
      value: "Ukraine",
    },
    {
      id: 234,
      label: "United Arab Emirates",
      value: "United Arab Emirates",
    },
    {
      id: 235,
      label: "United Kingdom of Great Britain and Northern Ireland",
      value: "United Kingdom of Great Britain and Northern Ireland",
    },
    {
      id: 236,
      label: "United States Minor Outlying Islands",
      value: "United States Minor Outlying Islands",
    },
    {
      id: 237,
      label: "United States of America",
      value: "United States of America",
    },
    {
      id: 238,
      label: "Uruguay",
      value: "Uruguay",
    },
    {
      id: 239,
      label: "Uzbekistan",
      value: "Uzbekistan",
    },
    {
      id: 240,
      label: "Vanuatu",
      value: "Vanuatu",
    },
    {
      id: 241,
      label: "Venezuela (Bolivarian Republic of)",
      value: "Venezuela (Bolivarian Republic of)",
    },
    {
      id: 242,
      label: "Vietnam",
      value: "Vietnam",
    },
    {
      id: 243,
      label: "Virgin Islands (British)",
      value: "Virgin Islands (British)",
    },
    {
      id: 244,
      label: "Virgin Islands (U.S.)",
      value: "Virgin Islands (U.S.)",
    },
    {
      id: 245,
      label: "Wallis and Futuna",
      value: "Wallis and Futuna",
    },
    {
      id: 246,
      label: "Western Sahara",
      value: "Western Sahara",
    },
    {
      id: 247,
      label: "Yemen",
      value: "Yemen",
    },
    {
      id: 248,
      label: "Zambia",
      value: "Zambia",
    },
    {
      id: 249,
      label: "Zimbabwe",
      value: "Zimbabwe",
    },
  ];

  const gender = [
    {
      id: 1,
      label: "Male",
      value: "Male",
    },
    {
      id: 2,
      label: "Female",
      value: "Female",
    },
    {
      id: 3,
      label: "Others",
      value: "Others",
    },
  ];

  const MaritalStatus = [
    {
      id: 1,
      label: "Single",
      value: "Single",
    },
    {
      id: 2,
      label: "Married",
      value: "Married",
    },
    {
      id: 3,
      label: "Widowed",
      value: "Widowed",
    },
    {
      id: 4,
      label: "Divorced",
      value: "Divorced",
    },
    {
      id: 5,
      label: "Separated",
      value: "Separated",
    },
  ];

  const onClose = () => {
    setModal(false);
    setEditData(null);
  };

  const handleUpdateUser = async (values) => {
    var data = JSON.stringify({
      ...(editData && { id: Number(editData?.id) }),
      contactDate: dayjs(editData?.contactDate).format("YYYY-MM-DD h:mm:ss"),
      Name: values?.Name,
      Nationality: values?.Nationality,
      dob: dayjs(editData?.dob).format("YYYY-MM-DD h:mm:ss"),
      Gender: values?.Gender,
      MaritalStatus: values?.MaritalStatus,
      ResignationNoticePeriod: values?.ResignationNoticePeriod,
      ExpectedDateOfJoining: dayjs(editData?.ExpectedDateOfJoining).format(
        "YYYY-MM-DD h:mm:ss"
      ),
      PositionAppliedFor: values?.PositionAppliedFor,
      ClientCompanyNameBeingInterviewedFor:
        values?.ClientCompanyNameBeingInterviewedFor,
      YearsOfToalExpereince: values?.YearsOfToalExpereince,
      YearsOfRelatedExperince: values?.YearsOfRelatedExperince,
      CurrentGrossSalary: values?.CurrentGrossSalary,
      ExpectedGrossSalary: values?.ExpectedGrossSalary,
      CountriesWorkedOtherThanHomeCountry:
        values?.CountriesWorkedOtherThanHomeCountry,
      HightestEducationQualification: values?.HightestEducationQualification,
      MedicalCertifications: values?.MedicalCertifications,
      CVSource: values?.CVSource,
      ContactNumber: values?.ContactNumber,
      WhatsApp: values?.WhatsApp,
      Email: values?.Email,
      CurrentLocation: values?.CurrentLocation,
      TypeOfVisa: values?.TypeOfVisa,
      ExpiryDateOfVisa: dayjs(editData?.ExpiryDateOfVisa).format(
        "YYYY-MM-DD h:mm:ss"
      ),
      Comments: values?.Comments,
      CVUploaded: values?.CVUploaded,
      Status: values?.Status,
    });
    setLoading(true);
    var config = {
      method: editData ? "put" : "post",
      url: "/api/tracker",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        message.success(response.data.message);
        setLoading(false);
        onClose();
        getData(filter);
      })
      .catch(function (error) {
        message.error(error?.response?.data?.error);
        setLoading(false);
      });
  };

  return (
    <Drawer
      title={editData ? "Update Tracker" : "Create Tracker"}
      placement="right"
      size="large"
      onClose={onClose}
      open={isModalOpen}
    >
      {isModalOpen && (
        <Form
          layout="vertical"
          className="grid-2"
          onFinish={handleUpdateUser}
          form={form}
          scrollToFirstError={true}
          initialValues={{
            contactDate:
              (editData?.contactDate &&
                dayjs(editData?.contactDate).isValid() &&
                dayjs(editData?.contactDate)) ||
              "",
            Name: editData?.Name,
            Nationality: editData?.Nationality,
            dob:
              (editData?.dob &&
                dayjs(editData?.dob).isValid() &&
                dayjs(editData?.dob)) ||
              "",
            Gender: editData?.Gender,
            MaritalStatus: editData?.MaritalStatus,
            ResignationNoticePeriod: editData?.ResignationNoticePeriod,
            ExpectedDateOfJoining:
              (editData?.ExpectedDateOfJoining &&
                dayjs(editData?.ExpectedDateOfJoining).isValid() &&
                dayjs(editData?.ExpectedDateOfJoining)) ||
              "",
            PositionAppliedFor: editData?.PositionAppliedFor,
            ClientCompanyNameBeingInterviewedFor:
              editData?.ClientCompanyNameBeingInterviewedFor,
            YearsOfToalExpereince: editData?.YearsOfToalExpereince,
            YearsOfRelatedExperince: editData?.YearsOfRelatedExperince,
            CurrentGrossSalary: editData?.CurrentGrossSalary,
            ExpectedGrossSalary: editData?.ExpectedGrossSalary,
            CountriesWorkedOtherThanHomeCountry:
              editData?.CountriesWorkedOtherThanHomeCountry,
            HightestEducationQualification:
              editData?.HightestEducationQualification,
            MedicalCertifications: editData?.MedicalCertifications,
            CVSource: editData?.CVSource,
            ContactNumber: editData?.ContactNumber,
            WhatsApp: editData?.WhatsApp,
            Email: editData?.Email,
            CurrentLocation: editData?.CurrentLocation,
            TypeOfVisa: editData?.TypeOfVisa,
            ExpiryDateOfVisa:
              (editData?.ExpiryDateOfVisa &&
                dayjs(editData?.ExpiryDateOfVisa).isValid() &&
                dayjs(editData?.ExpiryDateOfVisa)) ||
              "",
            Comments: editData?.Comments,
            CVUploaded: editData?.CVUploaded,
            Status: editData?.Status,
          }}
        >
          <Form.Item
            name="Name"
            label={"Candidate Name"}
            rules={[
              {
                required: true,
                message: "Please provide Name of Candidate",
              },
            ]}
          >
            <Input placeholder={"Enter Candidate Name"} />
          </Form.Item>
          <Form.Item
            name="contactDate"
            label={"Date of Contacting"}
            rules={[
              {
                required: true,
                message: "Please provide Contact Date",
              },
            ]}
          >
            <DatePicker format="YYYY-MM-DD" />
          </Form.Item>
          <Form.Item
            name="Gender"
            label={"Gender"}
            rules={[
              {
                required: true,
                message: "Please provide Gender",
              },
            ]}
          >
            <Select placeholder={"Please Select Gender"} options={gender} />
          </Form.Item>
          <Form.Item
            name="dob"
            label={"Date of Birth"}
            rules={[
              {
                required: true,
                message: "Please provide Date Of Birth",
              },
            ]}
          >
            <DatePicker format="YYYY-MM-DD" />
          </Form.Item>
          <Form.Item
            name="MaritalStatus"
            label={"Marital Status"}
            rules={[
              {
                required: true,
                message: "Please provide Marital Status",
              },
            ]}
          >
            <Select
              placeholder={"Please Select Marital Status"}
              options={MaritalStatus}
            />
          </Form.Item>
          <Form.Item
            name="ResignationNoticePeriod"
            label={"Resignation Notice Period"}
            rules={[
              {
                required: true,
                message: "Please provide Resignation Notice Period",
              },
            ]}
          >
            <Input placeholder={"Enter Resignation Notice Period"} />
          </Form.Item>
          <Form.Item
            name="ExpectedDateOfJoining"
            label={"Expected Date Of Joining"}
            rules={[
              {
                required: true,
                message: "Please provide Expected Date Of Joining",
              },
            ]}
          >
            <DatePicker format="YYYY-MM-DD" />
          </Form.Item>
          <Form.Item
            name="PositionAppliedFor"
            label={"Position Applied For"}
            rules={[
              {
                required: true,
                message: "Please provide Position Applied For",
              },
            ]}
          >
            <Input placeholder={"Enter Position Applied For"} />
          </Form.Item>
          <Form.Item
            name="ClientCompanyNameBeingInterviewedFor"
            label={"Client Company Name Being Interviewed For"}
            rules={[
              {
                required: true,
                message:
                  "Please provide Client Company Name Being Interviewed For",
              },
            ]}
          >
            <Input
              placeholder={"Enter Client Company Name Being Interviewed For"}
            />
          </Form.Item>
          <Form.Item
            name="YearsOfToalExpereince"
            label={"Years Of Toal Expereince"}
            rules={[
              {
                required: true,
                message: "Please provide Years Of Toal Expereince",
              },
            ]}
          >
            <Input placeholder={"Enter Years Of Toal Expereince"} />
          </Form.Item>
          <Form.Item
            name="YearsOfRelatedExperince"
            label={"Years Of Related Experince"}
            rules={[
              {
                required: true,
                message: "Please provide Years Of Related Experince",
              },
            ]}
          >
            <Input placeholder={"Enter Years Of Related Experince"} />
          </Form.Item>
          <Form.Item
            name="CurrentGrossSalary"
            label={"Current Gross Salary"}
            rules={[
              {
                required: true,
                message: "Please provide Current Gross Salary",
              },
            ]}
          >
            <Input placeholder={"Enter Current Gross Salary"} />
          </Form.Item>
          <Form.Item
            name="ExpectedGrossSalary"
            label={"Expected Gross Salary"}
            rules={[
              {
                required: true,
                message: "Please provide Expected Gross Salary",
              },
            ]}
          >
            <Input placeholder={"Enter Expected Gross Salary"} />
          </Form.Item>
          <Form.Item
            name="CountriesWorkedOtherThanHomeCountry"
            label={"Countries Worked Other Than Home Country"}
            rules={[
              {
                required: true,
                message:
                  "Please provide Countries Worked Other Than Home Country",
              },
            ]}
          >
            <Input
              placeholder={"Enter Countries Worked Other Than Home Country"}
            />
          </Form.Item>
          <Form.Item
            name="HightestEducationQualification"
            label={"Hightest Education Qualification"}
            rules={[
              {
                required: true,
                message: "Please provide Hightest Education Qualification",
              },
            ]}
          >
            <Input placeholder={"Enter Hightest Education Qualification"} />
          </Form.Item>
          <Form.Item
            name="MedicalCertifications"
            label={"Medical Certifications"}
            rules={[
              {
                required: true,
                message: "Please provide Medical Certifications",
              },
            ]}
          >
            <Input placeholder={"Enter Medical Certifications"} />
          </Form.Item>

          <Form.Item
            name="CVSource"
            label={"CV Source"}
            rules={[
              {
                required: true,
                message: "Please provide CV Source",
              },
            ]}
          >
            <Input placeholder={"Enter CV Source"} />
          </Form.Item>

          <Form.Item
            name="ContactNumber"
            label={"Contact Number"}
            rules={[
              {
                required: true,
                message: "Please provide Contact Number",
              },
            ]}
          >
            <Input placeholder={"Enter Contact Number"} />
          </Form.Item>

          <Form.Item
            name="WhatsApp"
            label={"WhatsApp"}
            rules={[
              {
                required: true,
                message: "Please provide WhatsApp",
              },
            ]}
          >
            <Input placeholder={"Enter WhatsApp"} />
          </Form.Item>

          <Form.Item
            name="Email"
            label={"Email"}
            rules={[
              {
                required: true,
                message: "Please provide Email",
              },
            ]}
          >
            <Input type="email" placeholder={"Enter Email"} />
          </Form.Item>

          <Form.Item
            name="CurrentLocation"
            label={"Current Location"}
            rules={[
              {
                required: true,
                message: "Please provide Current Location",
              },
            ]}
          >
            <Input placeholder={"Enter Current Location"} />
          </Form.Item>

          <Form.Item
            name="TypeOfVisa"
            label={"Type Of Visa"}
            rules={[
              {
                required: true,
                message: "Please provide Type Of Visa",
              },
            ]}
          >
            <Input placeholder={"Enter Type Of Visa"} />
          </Form.Item>

          <Form.Item
            name="ExpiryDateOfVisa"
            label={"Expiry Date Of Visa"}
            rules={[
              {
                required: true,
                message: "Please Expiry Date Of Visa",
              },
            ]}
          >
            <DatePicker format="YYYY-MM-DD" />
          </Form.Item>

          <Form.Item
            name="CVUploaded"
            label={"CV Uploaded"}
            rules={[
              {
                required: true,
                message: "Please provide CV Uploaded",
              },
            ]}
          >
            <Select placeholder={"Cv Upload"} options={cvuploaded} />
          </Form.Item>

          <Form.Item
            name="Nationality"
            label={"Nationality"}
            rules={[
              {
                required: true,
                message: "Please provide Nationality",
              },
            ]}
          >
            <Select placeholder={"Nationality"} options={nation} />
          </Form.Item>

          <Form.Item
            name="Status"
            label={"Status"}
            rules={[
              {
                required: true,
                message: "Please provide Status",
              },
            ]}
          >
            <Select placeholder={"Please Status"} options={status} />
          </Form.Item>

          <Form.Item
            className="grid-2-column"
            name="Comments"
            label={"Comments"}
          >
            <TextArea
              placeholder="Enter the comments"
              autoSize={{ minRows: 3 }}
            />
          </Form.Item>

          {/* <div className="flex-small-gap-column grid-2-column">
            <div className="text-black small-text">
              <span className="text-red">*</span> Candidate
            </div>
            <AsyncSelect
              className="custom-selection-box"
              loadOptions={grabCV}
              isClearable
              value={name}
              onChange={(value) => setName(value)}
              placeholder={"Select the candidate for interview"}
            />
          </div>
          <Form.Item
            name="client"
            label={"Client"}
            rules={[
              {
                required: true,
                message: "No client provided",
              },
            ]}
          >
            <Select
              placeholder={"Select the client"}
              options={clientsList}
              loading={clientFetching}
              disabled={clientFetching}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              showSearch
            />
          </Form.Item>
          <Form.Item
            name="job"
            label={"Job"}
            rules={[
              {
                required: true,
                message: "No job provided",
              },
            ]}
          >
            <Select
              placeholder={"Select the job"}
              options={jobsList}
              loading={jobFetching}
              disabled={jobFetching}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              showSearch
            />
          </Form.Item>
          <Form.Item
            name="start_date"
            label={"From Meeting time"}
            rules={[
              {
                required: true,
                message: "No time provided",
              },
            ]}
          >
            <DatePicker format="YYYY-MM-DD HH:mm:ss" showTime />
          </Form.Item>
          <Form.Item
            name="end_date"
            label={"To Meeting time"}
            rules={[
              {
                required: true,
                message: "No time provided",
              },
            ]}
          >
            <DatePicker format="YYYY-MM-DD HH:mm:ss" showTime />
          </Form.Item>
          <Form.Item
            name="location"
            label={"Location"}
            rules={[
              {
                required: true,
                message: "No location name provided",
              },
            ]}
          >
            <Input placeholder={"Enter location for interview"} />
          </Form.Item>
          <Form.Item
            name="status"
            label={"Interview Status"}
            rules={[
              {
                required: true,
                message: "No interview status provided",
              },
            ]}
          >
            <Select
              placeholder={"Select the status of interview"}
              options={status}
            />
          </Form.Item>
          <Form.Item
            className="grid-2-column"
            name="comment"
            label={"Comments"}
          >
            <TextArea
              placeholder="Enter the comments for interview"
              autoSize={{ minRows: 3 }}
            />
          </Form.Item> */}
          <div
            className="flex-at-end medium-margin-top"
            style={{ gridColumn: "1/3", gap: "1rem" }}
          >
            <Button className="" type="text" onClick={onClose}>
              Cancel
            </Button>
            <Button
              className=""
              type="primary"
              htmlType="submit"
              loading={isLoading}
            >
              {editData ? "Update" : "Create"}
            </Button>
          </div>
        </Form>
      )}
    </Drawer>
  );
};

export default RecruitmentTrackerForm;
